import React, { useState } from 'react';

import { Box, Menu, MenuItem, MenuList, Paper } from '@mui/material';
import { TeamIcon, TeamChip } from '@components';
import { Text } from 'components/common/ui';
import { styles } from './moveToTeam.style';

export const TEAMS = [
  'None',
  'Product',
  'Customer Success',
  'Sales',
  'Engineering',
  'Marketing',
  'Finance',
  'instaride',
  'Treasury',
  'Drivers',
  'HR',
  'Accounting',
  'Sourcing',
  'Credit Control',
];

const AddToTeam = ({ onMoveToTeam }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (team) => {
    if (onMoveToTeam) {
      onMoveToTeam(team);
    }
    handleMenuClose();
  };

  return (
    <>
      <Box sx={styles.wrapper} onClick={handleOpenMenu}>
        <TeamIcon />
        <Text sx={styles.text}>Move to team</Text>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={styles.menu}
      >
        <Paper sx={styles.paper}>
          <MenuList sx={styles.menuList}>
            {TEAMS?.map((item, index) => {
              return (
                <MenuItem
                  // eslint-disable-next-line react/no-array-index-key
                  key={`team-${index}`}
                  disabled={item?.disabled}
                  onClick={() => handleClick(item)}
                  sx={styles.menuItem}
                >
                  <TeamChip team={item} />
                </MenuItem>
              );
            })}
          </MenuList>
        </Paper>
      </Menu>
    </>
  );
};

export default AddToTeam;
